import React, { useState } from "react";
import { Modal, Button, Form, Tabs, Tab } from "react-bootstrap";
import { toast } from "react-toastify";
import { uploadInvoicePackagingDocAggregate, uploadInvoicePackagingDocFiveM, uploadInvoicePackagingDocTractor } from "../../services/ContainerMasterService";

function InvoicePackagingUploadModal({ show, hide, cell }) {
  const [value, setValue] = useState("");
  const [key, setKey] = useState("Upload Doc.");
  const [loading, setLoading] = useState("Upload");

  const handleFileSubmit = async () => {
    if (show.row.original.DataOf === "TRACTOR") {
      if (key === "Upload Doc.") {
        if (value && value.length > 0) {
          try {
            var formDataInvTractor = new FormData();
            for (const item of value) {
              formDataInvTractor.append("InvPackfiles", item, item.name.replace(/#/g, ""));
            }
            setLoading("Uploading");
            await uploadInvoicePackagingDocTractor(
              formDataInvTractor,
              show.row.original.ContainerMasterId
            );
            setLoading("Upload");
            hide();
            toast.success("Document Uploaded");
          } catch (error) {
            setLoading("Upload");
            toast.error("Something went wrong...please try again");
          }
        } else {
          toast.warn("Please select a file");
        }
      }
    }
    if (show.row.original.DataOf === "AGGREGATE") {
      if (key === "Upload Doc.") {
        if (value && value.length > 0) {
          try {
            var formDataInvAgg = new FormData();
            for (const item of value) {
              formDataInvAgg.append("InvPackAggfiles", item, item.name.replace(/#/g, ""));
            }
            setLoading("Uploading");
            await uploadInvoicePackagingDocAggregate(
              formDataInvAgg,
              show.row.original.ContainerMasterId
            );
            setLoading("Upload");
            hide();
            toast.success("Document Uploaded");
          } catch (error) {
            setLoading("Upload");
            toast.error("Something went wrong...please try again");
          }
        } else {
          toast.warn("Please select a file");
        }
      }
    }
    if (show.row.original.DataOf === "5M") {
      if (key === "Upload Doc.") {
        if (value && value.length > 0) {
          try {
            var formDataInv5M = new FormData();
            for (const item of value) {
              formDataInv5M.append("InvPackAggfiles", item, item.name.replace(/#/g, ""));
            }
            setLoading("Uploading");
            await uploadInvoicePackagingDocFiveM(
              formDataInv5M,
              show.row.original.ContainerMasterId
            );
            setLoading("Upload");
            hide();
            toast.success("Document Uploaded");
          } catch (error) {
            setLoading("Upload");
            toast.error("Something went wrong...please try again");
          }
        } else {
          toast.warn("Please select a file");
        }
      }
    }
  };

  return (
    <>
      <Modal show={show} backdrop="static" centered>
        <Modal.Body>
          <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
            <Tab eventKey="Upload Doc." title="Upload Doc.">
              <h5>Container No -{show.row.original.Container_Number}</h5>
              <Form.Group className="mb-3">
                <Form.Control
                  type="file"
                  multiple
                  className="file-modal-input"
                  onChange={(e) => setValue(e.target.files)}
                />
              </Form.Group>
              <Button
                className="fr mr-2 btn-sm"
                variant="outline-primary"
                onClick={() => {
                  hide();
                }}
              >
                Cancel
              </Button>
              <Button
                className="fr btn-sm"
                style={{ marginRight: "20px" }}
                onClick={handleFileSubmit}
                disabled={loading === "Uploading"}
              >
                {loading}
              </Button>
            </Tab>
          </Tabs>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default InvoicePackagingUploadModal;
